<div id="top" class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Annuler la Perte/Vol</div>
</div>

<!-- Cancelling still possible - sim card sending date is up to 3 days -->
<div>
    <div class="col-12 text-center">
        Je souhaite <strong>annuler ma déclaration de perte/vol et réactiver ma ligne {{line.phoneNumber}}.</strong>
        <br />
        <div class="w-100 text-center cta_container">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
        </div>
    </div>
</div>
